<template>
    <div
        class="flex justify-end mt-20 mb-5"
    >
        <menu-icon-close
            class="cursor-pointer w-10 h-8"
            @click="toggleSidebar"
        />
    </div>
    <div class="flex h-full flex-col justify-between">
        <div>
            <ul>
                <aside-menu-item
                    v-for="(item, index) in showMenu"
                    :key="index"
                    :item="item"
                    :is-submenu-list="isSubmenuList"
                    :is-aside-mobile="isAsideMobile"
                    :show-submenu-info="showSubmenuInfo"
                    @menu-click="menuClick"
                />
            </ul>
        </div>
        <div>
            <ul>
                <aside-menu-item
                    v-for="(item, bIndex) in bottomMenuList"
                    :key="bIndex"
                    :item="item"
                    :is-submenu-list="isSubmenuList"
                    :is-aside-mobile="isAsideMobile"
                    :show-submenu-info="showSubmenuInfo"
                    @menu-click="menuClick"
                />
            </ul>
        </div>
    </div>
</template>

<script setup>
import MenuIconClose from '@/assets/img/MenuIconClose'
import MenuIconOpen from '@/assets/img/MenuIconOpen'
import AsideMenuItem from '@/components/Utilities/AsideMenuItem'
import {computed} from 'vue'
import {useStore} from 'vuex'

const props = defineProps({
    isSubmenuList: {
        type: Boolean,
        default: false
    },
    menu: {
        type: Array,
        default: () => []
    },
    isAsideMobile: {
        type: Boolean,
        default: false
    },
    showSubmenuInfo: {
        type: Object,
        default: () => {}
    },
})
const emit = defineEmits(['menu-click', 'toggle-sidebar'])
const store = useStore()

const bottomMenuList = computed(() => {
    return props.menu.filter(m => m.isBottom)
})

const showMenu = computed(() => {
    if (!store.getters.inTeam) {
        return props.menu.filter(m => !m.showOnlyInTeam)
    }
    return props.menu.filter(m => !m.isBottom)
})
const menuClick = (event, item) => {
    emit('menu-click', event, item)
}

const toggleSidebar = () => {
    emit('toggle-sidebar')
}
</script>
